import { FC, useEffect, useMemo, useState } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { fetchCampaignCategoryItem } from '../../../network/campaignCategoryCrud';
import { CampaignCategoryFormMode, CampaignCategoryItem } from '../../../types/campaign-category';
import { NOT_FOUND_ERROR_PAGE_PATH } from '../../../../../common/constants';
import { useDispatch } from 'react-redux';
import { ApiErrorResponse } from 'src/app/common/network';
import { LayoutSplashScreen } from 'src/app/layout';
import CampaignCategoryForm from './components/CampaignCategoryForm';

const ConfigCampaignCategoryDetailPage: FC<RouteComponentProps> = ({ history }) => {
  const { id } = useParams<{ id: string }>();
  const { formMode, code } = useMemo(
    () => ({
      formMode: id ? CampaignCategoryFormMode.EDIT : CampaignCategoryFormMode.CREATE,
      code: id ? id : undefined,
    }),
    [id],
  );

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [campaignCategory, setCampaignCategory] = useState<CampaignCategoryItem>();

  const reloadData = () => {
    if (code) {
      setIsLoading(true);
      fetchCampaignCategoryItem(code, dispatch)
        .then((result) => {
          setCampaignCategory(result);
        })
        .catch((err: ApiErrorResponse) => {
          history.push(NOT_FOUND_ERROR_PAGE_PATH);
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [code]);

  return (
    <>
      {formMode === CampaignCategoryFormMode.CREATE && (
        <CampaignCategoryForm formMode={formMode} onReload={reloadData} onRouteTo={(route) => history.push(route)} />
      )}
      {formMode === CampaignCategoryFormMode.EDIT &&
        (isLoading || !campaignCategory ? (
          <LayoutSplashScreen />
        ) : (
          <CampaignCategoryForm
            code={code}
            formMode={formMode}
            campaignCategory={campaignCategory}
            onReload={reloadData}
            onRouteTo={(route) => history.push(route)}
          />
        ))}
    </>
  );
};

export default ConfigCampaignCategoryDetailPage;
